import { isAllowedBuyUrl } from "./buyUrlPolicy";

/**
 * Resolve the best outbound buy URL for a product.
 * Prefer affiliate when present so pasting tags later "just works".
 * Only retailer hosts from the price-check allowlist are returned.
 */
export function resolveProductBuyUrl(product) {
  if (!product) return "";
  const affiliate = String(product.affiliateUrl || "").trim();
  if (affiliate && isAllowedBuyUrl(affiliate)) return affiliate;
  const purchase = String(product.purchaseUrl || "").trim();
  if (purchase && isAllowedBuyUrl(purchase)) return purchase;
  return "";
}

export function resolveProductBuyLinkType(product) {
  if (String(product?.affiliateUrl || "").trim()) return "affiliate";
  if (String(product?.purchaseUrl || "").trim()) return "purchase";
  return "other";
}
